import { dateShort } from '../../common/utils/formatDate';
import {
  formatDecimalAsPercentage,
  abbreviateNumberToCurrency,
  roundNumberToNDecimalPlaces,
} from '../../common/utils/formatNumber';
import {
  Characteristics,
  CharacteristicsWithRank,
  ValueFormat,
} from './characteristics-table.model';
import { TemplateResult, html } from 'lit';

export function isCharacteristicsWithRank(
  characteristic: Characteristics,
): characteristic is CharacteristicsWithRank {
  if (characteristic.rank && Number.isInteger(parseInt(characteristic.rank))) {
    return true;
  }
  return false;
}

export function formatCharacteristicsValue(
  value: string | number,
  valueFormat?: string,
): string {
  if (valueFormat) {
    if (valueFormat === ValueFormat.percentage) {
      return formatDecimalAsPercentage(Number(value), 2);
    }
    if (valueFormat === ValueFormat.currency) {
      return abbreviateNumberToCurrency(Number(value), valueFormat, 2);
    }
    if (valueFormat === ValueFormat.date) {
      return dateShort(value.toString());
    }
    if (valueFormat === ValueFormat.years) {
      return `${roundNumberToNDecimalPlaces(Number(value), 2)} ${valueFormat}`;
    }
  }
  return value.toString();
}

export const generateHTML = (args): TemplateResult => html`
  <pop-characteristics-table-component
    data-product-code="${args?.productCode}"
    data-audience="${args?.audience}"
    data-country="${args?.country}"
    data-language="${args?.language}"
    data-component-object="${JSON.stringify(args?.componentObject)}"
  ></pop-characteristics-table-component>
`;
